import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, Loader2 } from "lucide-react";

import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api, formatError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: "", password: "" });

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/login", form);
      await refresh();
      nav("/admin");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="min-h-screen grid place-items-center px-5 bg-[#F6F8F6] text-[#052E16]"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md">
        <div className="text-center">
          <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-[#052E16] text-emerald-300">
            <ShieldCheck className="w-6 h-6" />
          </span>
          <h1 className="font-display mt-4 text-3xl font-extrabold tracking-tighter">
            Acesso Administrativo
          </h1>
          <p className="mt-2 text-neutral-600 text-sm">Área restrita.</p>
        </div>
        <form
          onSubmit={onSubmit}
          className="mt-8 rounded-2xl border border-neutral-200 bg-white p-6 md:p-8 grid gap-4"
          data-testid="admin-login-form"
        >
          <div>
            <Label htmlFor="email">E-mail</Label>
            <Input
              id="email"
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-1.5"
              data-testid="admin-input-email"
            />
          </div>
          <div>
            <Label htmlFor="password">Senha</Label>
            <Input
              id="password"
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-1.5"
              data-testid="admin-input-password"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="rounded-full bg-[#052E16] hover:bg-[#0a3a1f] hover:text-white text-white h-11"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
